import { observer } from 'mobx-react-lite';
import React from 'react';
import { getAlertDetailsComponent } from '../../../../../../../../../classes/factories/componentFactories';
import { useAlertFormStore } from '../../../alertFormClass';
import style from './SetupDetails.module.css';

export const SetupDetails = observer(() => {
  const form = useAlertFormStore();
  const setup = form.setup;
  if (setup === 'default') return null;
  const Component = getAlertDetailsComponent(setup);
  return (
    <div className={style.container}>
      <div></div>
      <Component />
    </div>
  );
});
